import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

/** NZ Govt Logo.  */
const NzGovtLogo = () => {
  const data = useStaticQuery(graphql`
    {
      file(name: { eq: "nzgovtlogo1" }) {
        id
        childImageSharp {
          gatsbyImageData(width: 400, layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
    }
  `);

  return (
    <GatsbyImage
      image={data.file.childImageSharp.gatsbyImageData}
      objectFit="contain"
      alt="endorsed by NZ govt"
    />
  );
};
export default NzGovtLogo;
